/// This file was generated DO NOT MODIFY
/// Source: EstimateType.cs
/// Tool: http://frhagn.github.io/Typewriter/pages/documentation.html

export enum EstimateTypeEnum {
  New = 'New', //0
  Reallocation = 'Reallocation', //1
  AdditionalService = 'AdditionalService', //2
  Import = 'Import', //3
  
}
